import script from "./front_page.vue?vue&type=script&setup=true&lang=js"
export * from "./front_page.vue?vue&type=script&setup=true&lang=js"

import "./front_page.vue?vue&type=style&index=0&id=380153fb&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380153fb"]])

export default __exports__